/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_error_register_passkey_failed = /** @type {(inputs: { error: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to register passkey: ${i?.error}`)
};

const zh_hans1_settings_error_register_passkey_failed = /** @type {(inputs: { error: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`注册通行密钥失败：${i?.error}`)
};

const zh_hant1_settings_error_register_passkey_failed = /** @type {(inputs: { error: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`註冊通行金鑰失敗：${i?.error}`)
};

const fr_settings_error_register_passkey_failed = /** @type {(inputs: { error: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’enregistrement du passkey : ${i?.error}`)
};

const de_settings_error_register_passkey_failed = /** @type {(inputs: { error: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passkey konnte nicht registriert werden: ${i?.error}`)
};

const ja_settings_error_register_passkey_failed = /** @type {(inputs: { error: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`パスキーの登録に失敗しました: ${i?.error}`)
};

const ko_settings_error_register_passkey_failed = /** @type {(inputs: { error: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`패스키를 등록하지 못했습니다: ${i?.error}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ error: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_error_register_passkey_failed = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_error_register_passkey_failed(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_error_register_passkey_failed", locale)
	if (locale === "en") return en_settings_error_register_passkey_failed(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_error_register_passkey_failed(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_error_register_passkey_failed(inputs)
	if (locale === "fr") return fr_settings_error_register_passkey_failed(inputs)
	if (locale === "de") return de_settings_error_register_passkey_failed(inputs)
	if (locale === "ja") return ja_settings_error_register_passkey_failed(inputs)
	return ko_settings_error_register_passkey_failed(inputs)
};